import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';  // Import App component

// Render the App component
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')  // Render it inside the 'root' div in index.html
);
